export enum ETipoVinculo {
    Parceiro = 1,
    Usuario = 2,
    Cadastro = 3,
}
